import * as React from "react";
import Box from "@mui/material/Box";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ClearIcon from "@mui/icons-material/Clear";
import Tooltip from "@mui/material/Tooltip";

export default function TabsPdf({
  pdfList,
  selectedDocuments,
  selectedPdf,
  handleChangePdfTab,
  removePdf,
  ...porps
}) {
  const filterPdfList = pdfList.filter((pdf) => {
    return selectedDocuments.includes(pdf.doc_id);
  });

  return (
    <Box
      sx={{
        flexGrow: 1,
        // maxWidth: { xs: 320, sm: 600 },
        bgcolor: "#333",
        color: "#fff",
      }}
    >
      <Tabs
        value={selectedPdf?.pdfLink}
        onChange={handleChangePdfTab}
        variant="scrollable"
        scrollButtons
        aria-label="visible arrows tabs example"
        sx={{
          [`& .${tabsClasses.scrollButtons}`]: {
            "&.Mui-disabled": { opacity: 0.3 },
          },
        }}
      >
        {filterPdfList?.map((pdf, index) => (
          <Tab
            // label={pdf?.title}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <span
                  onMouseEnter={(event) =>
                    (event.target.style.textDecoration = "underline")
                  }
                  onMouseLeave={(event) =>
                    (event.target.style.textDecoration = "none")
                  }
                >
                  {pdf?.code}-{pdf?.title}
                </span>
                {filterPdfList?.length > 1 ? (
                  <Tooltip
                    title="Remove Documnet"
                    placement="right-start"
                    arrow
                  >
                    <ClearIcon
                      sx={{
                        ml: 1,
                        cursor: "pointer",
                        "&:hover": {
                          color: "red",
                        },
                      }}
                      onClick={(event) => {
                        event.stopPropagation(); // Prevent the tab change when clicking the delete icon
                        removePdf(pdf);
                      }}
                    />
                  </Tooltip>
                ) : null}
              </Box>
            }
            value={pdf?.pdfLink}
            sx={{ color: "#ccc" }}
            key={pdf.doc_id}
          />
        ))}
      </Tabs>
    </Box>
  );
}
